import api from "./axios";

// Mock credentials for demo purposes
// In a real application, this would be handled securely on the backend
const ADMIN_USER = "admin";
const ADMIN_PASSWORD = "admin123";

const AuthService = {
	login: async (credentials) => {
		try {
			const response = await api.post("/auth/login", credentials);

			// Store token in localStorage
			localStorage.setItem("token", response.data.accessToken);
			localStorage.setItem("user", JSON.stringify(response.data.user));

			return response.data;
		} catch (error) {
			console.error("Error logging in:", error);
			throw error;
		}
	},

	register: async (credentials) => {
		try {
			const response = await api.post("/auth/register", credentials);

			// Store token in localStorage
			localStorage.setItem("token", response.data.accessToken);
			localStorage.setItem("user", JSON.stringify(response.data.user));

			return response.data;
		} catch (error) {
			console.error("Error registering:", error);
			throw error;
		}
	},

	logout: () => {
		localStorage.removeItem("token");
		localStorage.removeItem("user");
	},

	getCurrentUser: () => {
		const userStr = localStorage.getItem("user");
		if (userStr) {
			return JSON.parse(userStr);
		}
		return null;
	},

	isAuthenticated: () => {
		return !!localStorage.getItem("token");
	},
};

export default AuthService;
